var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQualified(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#D5EBFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44476_4866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.564 18.122L18.1879 15.1709C17.428 16.2773 16.2416 17.0651 14.8682 17.304L16.0202 19.7744C16.1675 20.0905 16.6233 20.0694 16.7419 19.7429L17.3324 18.121L17.4541 18.0642L19.0761 18.6547C19.4015 18.7741 19.7111 18.4368 19.564 18.122ZM13.9962 8C11.6246 8 9.69502 9.92949 9.69502 12.3012C9.69502 14.6728 11.6247 16.6023 13.9962 16.6023C16.3677 16.6023 18.2973 14.6728 18.2973 12.3012C18.2973 9.92949 16.3677 8 13.9962 8ZM16.089 11.9851L15.3263 12.7286L15.5066 13.7787C15.5617 14.0993 15.2239 14.3402 14.9391 14.1909L13.9962 13.6952L13.0533 14.1908C12.7669 14.3412 12.431 14.0975 12.4858 13.7787L12.6661 12.7286L11.9034 11.9851C11.6716 11.7591 11.8002 11.3646 12.1201 11.3182L13.1742 11.165L13.6457 10.2099C13.7884 9.91984 14.2039 9.91958 14.3468 10.2099L14.8182 11.165L15.8724 11.3182C16.1922 11.3646 16.3208 11.7591 16.089 11.9851ZM9.80449 15.1709L8.42834 18.122C8.28056 18.4383 8.59294 18.7737 8.91633 18.6546L10.5383 18.0642L10.66 18.1209L11.2504 19.7429C11.3688 20.0686 11.8246 20.0911 11.9722 19.7743L13.1242 17.304C11.7508 17.0651 10.5644 16.2773 9.80449 15.1709Z",
    fill: "#0889F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44476_4866"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualified);
export default __webpack_public_path__ + "static/media/qualified.1bc7cb3a788ede8eee16c550b4ba29e0.svg";
export { ForwardRef as ReactComponent };